<template>
  <div>
    <div
      class="zEWidget-launcher zEWidget-launcher--active"
      style="margin: 10px 45px; border: none; background: transparent; z-index: 999998; transform: translateZ(0px); position: fixed; transition-duration: 250ms; transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1); transition-property: opacity, top, bottom; opacity: 1; height: 50px; max-height: 551px; min-height: 50px; overflow: visible; right: 0px; bottom: 0px; width: 141px;"
    >
      <div class="right-1sM74 u-pullRight desktop-55rFI u-borderTransparent u-posRelative u-noPrint">
        <div>
          <div id="Embed">
            <button
              style="    box-shadow: none;background-color: #2695FF !important;color: #FFFFFF !important;fill: #FFFFFF !important;border-radius: 999rem;bottom: 0;letter-spacing: 0.6;font-size: 1.3rem;border: none !important;font-weight: 600;padding-top: 3px;"
              aria-haspopup="true"
              class="wrapper-AtBcr u-isActionable u-textLeft u-inlineBlock u-borderNone u-textBold u-textNoWrap Arrange Arrange--middle u-userLauncherColor "
            >
              {{ date1 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_TIME } from '@/store/actions.type';
import timeDotGov from '@/common/api/time';
export default {
  name: 'Clock',
  props: ['loading'],
  data() {
    return {
      done: false,
      date1: ''
    };
  },
  created() {
    this.syncClock();
  },
  methods: {
    syncClock() {
      timeDotGov.clockController.checkservertime();
      var _this = this;
      setInterval(function() {
        if (timeDotGov.data.currentTime) {
          let d = timeDotGov.clockController.runningclocks(true);
          if (d) {
            _this.$store.dispatch(SET_TIME, d.timestamp);
            _this.date1 = d.now;
            if (!_this.loading) _this.$emit('update:loading', true);
          }
        }
      }, 20);
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Clock.vue